import {
  Button,
  Card,
  CardHeader,
  CircularProgress,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';

import useCustomerProducts from 'core/hooks/useCustomerProducts';
import { useSchemaMeta } from 'Elements/Form/Schema';
import currency from 'Elements/Formats/currency';
import {
  Body,
  Column,
  GridTable,
  Header,
  Row as GridRow,
} from 'Elements/GridTable';
import LinkRow from 'Elements/GridTable/LinkRow';
import OverflowScroll from 'Elements/GridTable/OverflowScroll';

const Row = styled(GridRow)`
  grid-template-columns: 100px auto 100px;
`;

const CenterColumn = styled(Column)`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
`;

function CustomerProducts({ location }: RouteComponentProps) {
  const { customerId } = useSchemaMeta<{ customerId: number }>();
  const { products, loading } = useCustomerProducts(customerId);

  return (
    <Card elevation={1}>
      <CardHeader
        title="Tuotehinnasto"
        action={
          <Button
            disabled={!customerId}
            component={Link}
            to={`${location.pathname}/products`}
            variant="contained"
            color="primary"
            size="small"
          >
            Päivitä
          </Button>
        }
      />
      <GridTable>
        <Header>
          <Row>
            <Column>Koodi</Column>
            <Column>Nimi</Column>
            <Column align="right">Hinta</Column>
          </Row>
        </Header>

        <Body>
          <OverflowScroll height="235px">
            {products &&
              products.length > 0 &&
              products.map((product) => (
                <LinkRow to={'/products/' + product.id} key={product.id}>
                  <Row hover>
                    <Column>{product.code}</Column>
                    <Column>{product.name}</Column>
                    <Column align="right">
                      {currency.format(product.pivot.price)}
                    </Column>
                  </Row>
                </LinkRow>
              ))}

            {loading && (
              <Row>
                <CenterColumn>
                  <CircularProgress />
                </CenterColumn>
              </Row>
            )}

            {!loading && (!products || products.length === 0) && (
              <Row>
                <CenterColumn>
                  <Typography variant="subtitle1">
                    Asiakkaalla ei ole tuotehintoja.
                  </Typography>
                </CenterColumn>
              </Row>
            )}
          </OverflowScroll>
        </Body>
      </GridTable>
    </Card>
  );
}

export default withRouter(CustomerProducts);
